import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Transactions } from "types/Models/books";

const initialState = {
  isOpen: false,
  isSnackbarOpen: false,
  updateTxnResponse: {},
};

export const similarTransactionsSlice = createSlice({
  name: "similarTransactions",
  initialState,
  reducers: {
    openSimilarTxnsModal: (state) => {
      state.isOpen = true;
      state.isSnackbarOpen = false;
    },
    closeSimilarTxnModal: (state) => {
      state.isOpen = false;
    },
    openSimilarTxnsSnackbar: (state) => {
      state.isSnackbarOpen = true;
    },
    closeSimilarTxnsSnackbar: (state) => {
      state.isSnackbarOpen = false;
    },
    setUpdateTxnResponse: (state, action: PayloadAction<Transactions>) => {
      state.updateTxnResponse = action.payload;
    },
  },
});

export const {
  openSimilarTxnsModal,
  closeSimilarTxnModal,
  openSimilarTxnsSnackbar,
  closeSimilarTxnsSnackbar,
  setUpdateTxnResponse,
} = similarTransactionsSlice.actions;

export default similarTransactionsSlice.reducer;
